let defaultProfile = {
    id: '',
    name: '',
    email: '',
    avatar: '',
    phoneNumber: '',
    password: '',
    roleName: '',
};

export default defaultProfile;

